import {
  Alert,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { isValidEmail } from "../../../Helpers/utilsHelper";
import { LoadingButton } from "@mui/lab";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { ErrorOutline, Warning } from "@material-ui/icons";
import useNotification from "../../../hooks/useNotification";
import IndicationCreationCompte from "../shares/extra/IndicationCreationCompte";

const INIT_USER_DATA = {
  nom: "",
  prenoms: "",
  annee_naissance: "",
  adresse: "",
  telephone: "",
  email: "",
  password: "",
  confirm_password: "",
  is_association: "1",
};

const INIT_FORM_ERROR = {
  nomError: null,
  prenomsError: null,
  annee_naissanceError: null,
  adresseError: null,
  telephoneError: null,
  mailError: null,
  passwordError: null,
  confirm_passwordError: null,
  typeCompteError: null,
};

const LIBELLE_ATTRIBUTS = [
  {
    nom: "Votre nom *",
    prenom: "Votre prenoms *",
    annee_naissance: "Votre année de naissance *",
    adresse: "Votre adresse *",
    telephone: "Votre numero de telephone *",
  },
  {
    nom: "Nom du representant de l'association *",
    prenom: "Prenoms du representant de l'association *",
    annee_naissance: "Année de naissance du representant de l'association *",
    adresse: "Adresse du representant de l'association *",
    telephone: "Numero de telephone du representant de l'association *",
  },
  {
    nom: "Nom du representant *",
    prenom: "Prenoms du representant *",
    annee_naissance: "Année de naissance du representant *",
    adresse: "Adresse du representant *",
    telephone: "Numero de telephone du representant *",
  },
];

const RegistrationPage = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [submited, setSubmitted] = useState(false);
  const [formError, setFormError] = useState(INIT_FORM_ERROR);
  const [userData, setUserData] = useState(INIT_USER_DATA);
  const [dataValid, setDataValide] = useState(false);
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();

  const checkDataValidation = () => {
    let ok = false;
    // if (submited) {
    setFormError({
      ...formError,
      nomError:
        userData.nom.trim() === "" ? "Le champ nom est obligatoire" : null,
      annee_naissanceError:
        userData.annee_naissance === ""
          ? "Le champ année de naissance est obligatoire"
          : userData.annee_naissance > new Date().getFullYear() - 10
            ? "Vous devez avoir au moins 10 ans"
            : new Date().getFullYear() - userData.annee_naissance > 100
              ? "Veuillez verifier votre année de naissance"
              : null,
      telephoneError:
        userData.telephone.trim() === ""
          ? "Le champ telephone est obligatoire"
          : String(userData.telephone).length < 6 || !/^[+0-9]/.test(userData.telephone)
            ? "Veuillez verifier le numero de telephone"
            : null,
      mailError: !isValidEmail(userData.email)
        ? "Veuillez entrer un email valide"
        : null,
      passwordError:
        userData.password.length < 6
          ? "Le mot de passe doit contenir au moins 6 caractères"
          : null,
      confirm_passwordError: userData.confirm_password
        ? userData.confirm_password !== userData.password
          ? "Vous avez mis deux mot de passe différents"
          : null
        : "Veuillez confirmer le mot de passe",
      typeCompteError: !userData.is_association
        ? "Type de compte requis"
        : null,
    });
    // } else {
    //   setFormError(INIT_FORM_ERROR);
    //   ok = false;
    // }

    setDataValide(Object.values(formError).every((error) => error === null));
    ok = Object.values(formError).every((error) => error === null);
    return ok;
  };

  const handleShowSuccessNotification = () => {
    showNotification(
      "Notification",
      "Création du compte avec succès. Vous allez recevoir un email pour l'activation de votre compte",
      TYPE_NOTIFICATION.SUCCESS,
      () => {
        navigate("/login");
      },
    );
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setloading(true);
    if (checkDataValidation()) {
      AuthService.register(userData)
        .then((res) => {
          if (res && res.success) {
            setFormError(INIT_FORM_ERROR);
            handleShowSuccessNotification();
          } else {
            //showToast(TYPE_NOTIFICATION.ERROR, res.message);
            showNotification(
              "Erreur",
              res.message,
              TYPE_NOTIFICATION.ERROR,
              () => {},
            );
          }
        })
        .finally(() => {
          setloading(false);
        });
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez verifier les champs du formulaire",
      );
      setloading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    }
    if (userData) {
      console.log(userData);
      setDataValide(checkDataValidation());
    }
  }, [userData]);

  return (
    <>
      <NotificationComponent />
      <Toast />
      <Grid container display={"flex"} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} xl={4}>
          <Grid mb={5}>
            <IndicationCreationCompte />
          </Grid>
          <Paper sx={{ p: 3 }}>
            <Grid item>
              <Grid item display={"flex"} justifyContent={"center"}>
                {FID_LOGO}
              </Grid>
              <Grid item display={"flex"} flexDirection={"column"}>
                <h3>Inscrivez-vous</h3>
                <FormControl>
                  <label>Type de compte*</label>
                  <RadioGroup
                    row
                    name="is_association"
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        is_association: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="0"
                      disabled
                      checked={userData.is_association === "0"}
                      control={<Radio />}
                      label="Consultant individuel"
                    />
                    <FormControlLabel
                      value="1"
                      checked={userData.is_association === "1"}
                      control={<Radio />}
                      label="Association/Volontaire"
                    />
                    <FormControlLabel
                      value="2"
                      checked={userData.is_association === "2"}
                      control={<Radio />}
                      label="AGEX/Cabinet"
                    />
                  </RadioGroup>
                  <Alert
                    variant="outlined"
                    icon={<Warning />}
                    color="error"
                    sx={{
                      display: formError.typeCompteError ? "" : "none",
                    }}
                  >
                    {formError.typeCompteError}
                  </Alert>
                </FormControl>
                <FormControl>
                  <label>{`${LIBELLE_ATTRIBUTS[userData.is_association].nom}`}</label>
                  <TextField
                    id="nom"
                    name="nom"
                    size="small"
                    placeholder={`${LIBELLE_ATTRIBUTS[userData.is_association].nom}`}
                    fullWidth
                    aria-describedby="nom_helper"
                    onChange={(e) => handleChange(e)}
                    value={userData.nom}
                    error={formError.nomError}
                    helperText={formError.nomError}
                  />
                </FormControl>
                <FormControl>
                  <label>{`${LIBELLE_ATTRIBUTS[userData.is_association].prenom}`}</label>
                  <TextField
                    id="prenoms"
                    name="prenoms"
                    size="small"
                    placeholder={`${LIBELLE_ATTRIBUTS[userData.is_association].prenom}`}
                    aria-describedby="prenoms_helper"
                    value={userData.prenoms}
                    error={formError.prenomsError}
                    onChange={(e) => handleChange(e)}
                    helperText={formError.prenomsError}
                  />
                </FormControl>
                <FormControl>
                  <label>{`${LIBELLE_ATTRIBUTS[userData.is_association].annee_naissance}`}</label>
                  <TextField
                    id="annee_naissance"
                    name="annee_naissance"
                    type="number"
                    min={1900}
                    max={new Date().getFullYear() - 10}
                    size="small"
                    onChange={(e) => handleChange(e)}
                    error={formError.annee_naissanceError}
                    helperText={formError.annee_naissanceError}
                    placeholder={`${LIBELLE_ATTRIBUTS[userData.is_association].annee_naissance}`}
                    aria-describedby="annee_naissance_helper"
                    value={userData.annee_naissance}
                  />
                </FormControl>
                <FormControl>
                  <label>{`${LIBELLE_ATTRIBUTS[userData.is_association].adresse}`}</label>
                  <TextField
                    id="adresse"
                    name="adresse"
                    size="small"
                    placeholder={`${LIBELLE_ATTRIBUTS[userData.is_association].adresse}`}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    aria-describedby="adresse_helper"
                    error={formError.adresseError}
                    helperText={formError.adresseError}
                    value={userData.adresse}
                  />
                </FormControl>
                <FormControl>
                  <label>{`${LIBELLE_ATTRIBUTS[userData.is_association].telephone}`}</label>
                  <TextField
                    id="telephone"
                    name="telephone"
                    size="small"
                    placeholder="ex: +261340000000"
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    aria-describedby="telephone_helper"
                    error={formError.telephoneError}
                    helperText={formError.telephoneError}
                    value={userData.telephone}
                  />
                </FormControl>
                <FormControl>
                  <label>Adresse email *</label>
                  <TextField
                    id="email"
                    name="email"
                    type="email"
                    size="small"
                    placeholder="Adresse email"
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    aria-describedby="email_helper"
                    error={formError.mailError}
                    helperText={formError.mailError}
                    value={userData.email}
                  />
                </FormControl>
                <FormControl>
                  <label>Mot de passe *</label>
                  <TextField
                    id="password"
                    name="password"
                    type="password"
                    size="small"
                    placeholder="Mot de passe"
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    aria-describedby="password_helper"
                    error={formError.passwordError}
                    helperText={formError.passwordError}
                    value={userData.password}
                  />
                </FormControl>
                <FormControl>
                  <label>Confirmer mot de passe *</label>
                  <TextField
                    id="confirm_password"
                    name="confirm_password"
                    type="password"
                    size="small"
                    placeholder="Mot de passe"
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    aria-describedby="confirm_password_helper"
                    error={formError.confirm_passwordError}
                    helperText={formError.confirm_passwordError}
                    value={userData.confirm_password}
                  />
                </FormControl>
                <Grid
                  item
                  display={"flex"}
                  justifyContent="center"
                  alignItems="center"
                  pt={5}
                >
                  <LoadingButton
                    loading={loading}
                    variant="contained"
                    type="submit"
                    onClick={handleSubmit}
                    // disabled={dataValid}
                    fullWidth
                  >
                    S'inscrire
                  </LoadingButton>
                </Grid>
                <Grid
                  item
                  xs={12}
                  mt={3}
                  display={"flex"}
                  justifyContent="center"
                >
                  <Link to={"/login"} style={{ textDecoration: "none" }}>
                    Déjà inscrit ? Connectez-vous
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default RegistrationPage;
